require('./RAPortfolioCompositionTable.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
// @ components
const { ComparativeBarComposed } = require('components/comparativeBarComposed/comparativeBarComposed');
// @ utilities
const RAAssetsHelper = require('utilities/RAAssetsHelper');
import { FormattedText } from 'core/i18n';
const { formatPercentageWithDecimals, formatWithoutRound } = require('utilities/RACurrencyHelper');
// @ constants
const {
    ACTIVE_CLASS_MONEY_MARKET_ID,
    ACTIVE_CLASS_FIXED_INCOME_ID,
    ACTIVE_CLASS_EQUITY_ID,
    ACTIVE_CLASS_REAL_ASSETS_ID,
    RA_POTFOLIO_COMPOSITION_TABLE_DECIMAL_LENGTH,
    SECONDARY_BAR_COLOR,
    PERCENTAGE_SYMBOL,
    EURO_SYMBOL,
} = require('constants/RAConstants/index');

class RAPortfolioCompositionTable extends React.Component {
    getRowClass(assetClassId) {
        const customClass = classNames('ra-portfolio-composition-table__row', {
            ['ra-portfolio-composition-table__row--money-market']: assetClassId === ACTIVE_CLASS_MONEY_MARKET_ID,
            ['ra-portfolio-composition-table__row--fixed-income']: assetClassId === ACTIVE_CLASS_FIXED_INCOME_ID,
            ['ra-portfolio-composition-table__row--equity']: assetClassId === ACTIVE_CLASS_EQUITY_ID,
            ['ra-portfolio-composition-table__row--real-assets']: assetClassId === ACTIVE_CLASS_REAL_ASSETS_ID,
        });

        return customClass;
    }

    buildTableHeader() {
        return (
            <OKTableRow className="ra-portfolio-composition-table__header-row">
                <OKTableCell className="ra-portfolio-composition-table__header-cell ra-portfolio-composition-table__header-cell--first">
                    <div className="ra-portfolio-composition-table__header-content">
                        <FormattedText value="raPortfolioCompositionTable-activeSubClassLabel" />
                    </div>
                </OKTableCell>
                <OKTableCell className="ra-portfolio-composition-table__header-cell ra-portfolio-composition-table__header-cell--second" />
                <OKTableCell className="ra-portfolio-composition-table__header-cell ra-portfolio-composition-table__header-cell--third">
                    <div className="ra-portfolio-composition-table__header-content">
                        {' '}
                        <FormattedText
                            value="raPortfolioCompositionTable-portfolioPercentageLabel"
                            className="ra-portfolio-composition-table__header-content"
                        />
                    </div>
                </OKTableCell>
                <OKTableCell className="ra-portfolio-composition-table__header-cell ra-portfolio-composition-table__header-cell--last">
                    <div className="ra-portfolio-composition-table__header-content">
                        <FormattedText
                            value="raPortfolioCompositionTable-amountLabel"
                            className="ra-portfolio-composition-table__header-content"
                        />
                    </div>
                </OKTableCell>
            </OKTableRow>
        );
    }

    buildTableBody(immAssetAllocations) {
        const { immManagementPlan } = this.props;
        const tableRows = [];
        const initialContributionAmount = immManagementPlan.get('initialContributionAmount');

        immAssetAllocations.forEach(assetAllocation => {
            const assetClassId = assetAllocation.get('assetClassId');
            const assetClass = assetAllocation.get('assetClass');
            const rowClass = this.getRowClass(assetClassId);
            const barColor = RAAssetsHelper.getBarColor(assetClassId);
            const subAssetClasses = assetAllocation.get('subAssetClasses');
            const getSortedValue = a => Number(a.get('subAssetClassId').slice(-3));
            const sortedSubAssetClasses = subAssetClasses.sort((a, b) => getSortedValue(a) - getSortedValue(b));

            sortedSubAssetClasses.forEach((immSubAssetClass, index) => {
                const subAssetClass = immSubAssetClass.get('subAssetClass');
                const subAssetClassId = immSubAssetClass.get('subAssetClassId');
                const subAssetWeightPercentage = formatPercentageWithDecimals(immSubAssetClass.get('weight'));
                const assets = immSubAssetClass.get('assets');
                const assetsSize = assets.size;
                tableRows.push(
                    <OKTableRow key={`${subAssetClassId}_${index}`} className={rowClass}>
                        <OKTableCell className="ra-portfolio-composition-table__cell ra-portfolio-composition-table__cell--first">
                            <div>
                                <span className="ra-portfolio-composition-table__cell-content-first-asset ra-portfolio-composition-table__cell-content-first-asset--bold">
                                    {assetClass} - {subAssetClass}
                                </span>
                            </div>
                        </OKTableCell>
                        <OKTableCell className="ra-portfolio-composition-table__cell ra-portfolio-composition-table__cell--second">
                            <div className="ra-portfolio-composition-table__cell ra-portfolio-composition-table__cell--second__wrapper">
                                <span className="ra-portfolio-composition-table__cell-content-second ra-portfolio-composition-table__cell-percentage">
                                    {subAssetWeightPercentage}
                                </span>
                            </div>
                        </OKTableCell>
                        <OKTableCell className="ra-portfolio-composition-table__cell ra-portfolio-composition-table__cell--third">
                            <div className="ra-portfolio-composition-table__comparative-bar">
                                <ComparativeBarComposed
                                    firstValue={subAssetWeightPercentage}
                                    secondValue={100 - subAssetWeightPercentage}
                                    totalValue={100}
                                    firstColor={barColor}
                                    secondColor={SECONDARY_BAR_COLOR}
                                    height={10}
                                />
                            </div>
                        </OKTableCell>
                        <OKTableCell className="ra-portfolio-composition-table__cell ra-portfolio-composition-table__cell--last" />
                    </OKTableRow>
                );

                assets.forEach((immAsset, index) => {
                    const assetName = immAsset.get('fundName');
                    const isin = immAsset.get('isin');
                    const fundRowClass = classNames(rowClass, 'ra-portfolio-composition-table__cell-fund-row', {
                        'ra-portfolio-composition-table__cell-fund-row--last': assetsSize === index + 1,
                    });
                    const assetWeight = immAsset.get('weight');
                    const assetPercentage = assetsSize > 1 ? formatPercentageWithDecimals(assetWeight) : '';
                    const amount = formatWithoutRound(
                        assetWeight * initialContributionAmount,
                        RA_POTFOLIO_COMPOSITION_TABLE_DECIMAL_LENGTH
                    );
                    const lastTableCellClass = classNames('ra-portfolio-composition-table__cell', {
                        'ra-portfolio-composition-table__cell--second': screen.width < 480,
                        'ra-portfolio-composition-table__cell--last': screen.width >= 480,
                    });
                    tableRows.push(
                        <OKTableRow key={`${isin}_${assetName}_${assetWeight}`} className={fundRowClass}>
                            <OKTableCell className="ra-portfolio-composition-table__cell ra-portfolio-composition-table__cell--first">
                                <span className="ra-portfolio-composition-table__cell-content-first-asset">
                                    {assetName}
                                </span>
                            </OKTableCell>
                            <OKTableCell className="ra-portfolio-composition-table__cell ra-portfolio-composition-table__cell--second">
                                {assetPercentage}
                            </OKTableCell>
                            <OKTableCell className="ra-portfolio-composition-table__cell ra-portfolio-composition-table__cell--third" />
                            <OKTableCell className={lastTableCellClass}>
                                <div className="ok-table-cell ra-portfolio-composition-table__cell ra-portfolio-composition-table__cell--last__wrapper">
                                    <span className="ra-portfolio-composition-table__cell-content-second ra-portfolio-composition-table__cell-amount">
                                        {amount} {EURO_SYMBOL}
                                    </span>
                                </div>
                            </OKTableCell>
                        </OKTableRow>
                    );
                });
            });
        });

        return tableRows;
    }

    buildTableFooter() {
        const { immManagementPlan } = this.props;
        const initialContributionAmount = immManagementPlan.get('initialContributionAmount');
        const totalPercentage = formatPercentageWithDecimals(1, false);
        const amount = formatWithoutRound(initialContributionAmount, RA_POTFOLIO_COMPOSITION_TABLE_DECIMAL_LENGTH);

        return (
            <OKTableRow className="ra-portfolio-composition-table__footer-row">
                <OKTableCell className="ra-portfolio-composition-table__footer-cell ra-portfolio-composition-table__footer-cell--first">
                    <div className="ra-portfolio-composition-table__footer-content-first">
                        <FormattedText value="raPortfolioCompositionTable-totalLabel" />
                    </div>
                </OKTableCell>
                <OKTableCell className="ra-portfolio-composition-table__footer-cell" />
                <OKTableCell className="ra-portfolio-composition-table__footer-cell--third">
                    <span className="ra-portfolio-composition-table__footer-content-percentage">
                        {totalPercentage} {PERCENTAGE_SYMBOL}
                    </span>
                </OKTableCell>
                <OKTableCell className="ra-portfolio-composition-table__footer-cell--last">
                    <span className="ra-portfolio-composition-table__footer-content-last">
                        {amount} {EURO_SYMBOL}
                    </span>
                </OKTableCell>
            </OKTableRow>
        );
    }

    render() {
        const { immAssetAllocations } = this.props;
        const tableHeader = this.buildTableHeader();
        const tableBody = this.buildTableBody(immAssetAllocations);
        const tableFooter = this.buildTableFooter();

        return (
            <OKTable className="ra-portfolio-composition-table">
                <thead>{tableHeader}</thead>
                <tbody>{tableBody}</tbody>
                <tfoot>{tableFooter}</tfoot>
            </OKTable>
        );
    }
}

RAPortfolioCompositionTable.propTypes = {
    immAssetAllocations: PropTypes.object.isRequired,
    immManagementPlan: PropTypes.object.isRequired,
};

module.exports = RAPortfolioCompositionTable;
